import React from 'react'
import PropTypes from 'prop-types'
import config from '../../../config'
import { Link, graphql, StaticQuery } from 'gatsby'
// import MessengerCustomerChat from 'react-messenger-customer-chat';

function setdarkMode(){
  if ((global.localStorage.getItem('theme')==undefined) || (global.localStorage.getItem('theme')=='normal')){
    global.localStorage.setItem('theme', 'dracula');
    console.log(global.localStorage.getItem('theme'));
    console.log('is it dark yet?: yes');
    darkMode();

  } else {
    global.localStorage.setItem('theme', 'normal');
    console.log(global.localStorage.getItem('theme'));
    console.log('is it dark yet?: no');
    darkMode();
  }
}

function darkMode(){
  var hours = new Date().getHours();
  console.log(hours);
  if(global.localStorage.getItem('theme')==undefined)
  {
    if(hours>=6 && hours<22)
    {
      global.localStorage.setItem('theme', 'normal');
    }
    else
    {
      global.localStorage.setItem('theme', 'dracula');
    }
  }

  if (global.localStorage.getItem('theme')=='dracula'){
  document.querySelector("nav").style.backgroundColor = 'black';
  document.getElementsByClassName("navbar-item")[0].firstChild.src =  '/img/ao_ukraina-w.svg';
  document.querySelector("html").style.backgroundColor = 'black';
  document.getElementById('dark-mode-btn').innerText = 'light mode';
  document.getElementById('dark-mode-img').src = '/img/sun.svg';

  for (let i=0; i<document.getElementsByClassName("navbar-item").length;i++){
    document.getElementsByClassName("navbar-item")[i].classList.add('dmode');
  }

  document.getElementById('navMenu').style.backgroundColor = 'black';

  for (let i=0; i<document.querySelectorAll("h1").length;i++){
    document.querySelectorAll("h1")[i].classList.add('dmode-light');
  }
  for (let i=0; i<document.querySelectorAll("h2").length;i++){
    document.querySelectorAll("h2")[i].classList.add('dmode-light');
  }
  for (let i=0; i<document.querySelectorAll("h3").length;i++){
    document.querySelectorAll("h3")[i].classList.add('dmode-imp');
  }
  for (let i=0; i<document.querySelectorAll("h4").length;i++){
    document.querySelectorAll("h4")[i].classList.add('dmode-imp');
  }
  for (let i=0; i<document.querySelectorAll("h5").length;i++){
    document.querySelectorAll("h5")[i].classList.add('dmode-imp');
  }
  for (let i=0; i<document.querySelectorAll("h6").length;i++){
    document.querySelectorAll("h6")[i].classList.add('dmode-imp');
  }
  for (let i=0; i<document.querySelectorAll("ul").length;i++){
    document.querySelectorAll("ul")[i].classList.add('dmode-green');
  }
  for (let i=0; i<document.querySelectorAll("li").length;i++){
    document.querySelectorAll("li")[i].classList.add('dmode');
  }
  for (let i=0; i<document.querySelectorAll("ol").length;i++){
    document.querySelectorAll("ol")[i].classList.add('dmode');
  }
  for (let i=0; i<document.querySelectorAll("p").length;i++){
    document.querySelectorAll("p")[i].classList.remove('lmode');
  }

  for (let i=0; i<document.getElementsByClassName("offp").length;i++){
    document.getElementsByClassName("offp")[i].classList.add('dmode');
  }

  for (let i=0; i<document.querySelectorAll("p").length;i++){
    document.querySelectorAll("p")[i].classList.add('dmode');
  }
  for (let i=0; i<document.querySelectorAll("sub").length;i++){
    document.querySelectorAll("sub")[i].classList.remove('lmode');
  }
  for (let i=0; i<document.querySelectorAll("sub").length;i++){
    document.querySelectorAll("sub")[i].classList.add('dmode');
  }

  for (let i=0; i<document.querySelectorAll("strong").length;i++){
    document.querySelectorAll("strong")[i].classList.add('dmode-green2');
  }
  for (let i=0; i<document.querySelectorAll("small").length;i++){
    document.querySelectorAll("small")[i].classList.add('dmode-green');
  }

  }
  else {
    document.querySelector("nav").style.backgroundColor = 'white';
    document.getElementsByClassName("navbar-item")[0].firstChild.src =  '/img/ao_ukraina.svg';
    document.querySelector("html").style.backgroundColor = 'white';
    document.getElementById('dark-mode-btn').innerText = 'dark mode';
    document.getElementById('dark-mode-img').src = '/img/moon.svg';

    for (let i=0; i<document.getElementsByClassName("navbar-item").length;i++){
      document.getElementsByClassName("navbar-item")[i].classList.remove('dmode');
    }

    document.getElementById('navMenu').style.backgroundColor = 'white';

    for (let i=0; i<document.querySelectorAll("h1").length;i++){
      document.querySelectorAll("h1")[i].classList.remove('dmode-light');
    }
    for (let i=0; i<document.querySelectorAll("h2").length;i++){
      document.querySelectorAll("h2")[i].classList.remove('dmode-light');
    }
    for (let i=0; i<document.querySelectorAll("h3").length;i++){
      document.querySelectorAll("h3")[i].classList.remove('dmode-imp');
    }
    for (let i=0; i<document.querySelectorAll("h4").length;i++){
      document.querySelectorAll("h4")[i].classList.remove('dmode-imp');
    }
    for (let i=0; i<document.querySelectorAll("h5").length;i++){
      document.querySelectorAll("h5")[i].classList.remove('dmode-imp');
    }
    for (let i=0; i<document.querySelectorAll("h6").length;i++){
      document.querySelectorAll("h6")[i].classList.remove('dmode-imp');
    }
    for (let i=0; i<document.querySelectorAll("ul").length;i++){
      document.querySelectorAll("ul")[i].classList.remove('dmode-green');
    }
    for (let i=0; i<document.querySelectorAll("li").length;i++){
      document.querySelectorAll("li")[i].classList.remove('dmode');
    }
    for (let i=0; i<document.querySelectorAll("ol").length;i++){
      document.querySelectorAll("ol")[i].classList.remove('dmode');
    }
    for (let i=0; i<document.querySelectorAll("p").length;i++){
      document.querySelectorAll("p")[i].classList.remove('dmode');
    }
    for (let i=0; i<document.getElementsByClassName("offp").length;i++){
      document.getElementsByClassName("offp")[i].classList.remove('dmode');
    }
    for (let i=0; i<document.querySelectorAll("sub").length;i++){
      document.querySelectorAll("sub")[i].classList.remove('dmode');
    }
    for (let i=0; i<document.querySelectorAll("strong").length;i++){
      document.querySelectorAll("strong")[i].classList.remove('dmode-green2');
    }
    for (let i=0; i<document.querySelectorAll("small").length;i++){
      document.querySelectorAll("small")[i].classList.remove('dmode-green');
    }

  }

}


class Footer extends React.Component {
    componentDidMount(){
    darkMode();
  }
  render() {
    const { data } = this.props
    const { edges: posts } = data.allMarkdownRemark


    return (
    <footer className='footer' style={{alignItems:'bottom', paddingBottom:'30px'}}>

      <div className='container'>
        <div style={{textAlign:'center'}}>
          <Link to="/"><img width="200px" src='/img/ao_ukraina-w.svg' id="logo-footer" alt="Art Open advertising agency" /></Link>
          <br></br>
        </div>
      <br></br>
      <div className='section columns' style={{marginLeft:'3%'}}>

        <div className='column' style={{ padding:'5px',marginTop:'30px'}}>
          <h5><b><Link style={{color:'white'}} to="/offer/">Offer</Link></b></h5>
          <br />
        {/* <Link className='submenu-item' to='/offer/covid-19/'>
          <img width="10px" className='icon-green'  alt="covid-19" src='/img/viruses.svg'/>
            Covid-19
          </Link>*/}

          <Link className='submenu-item' to='/offer/ecology/'>
          <img width="10px" className='icon-green'  alt="ecology" src='/img/leaf.svg'/>
            Ecology
          </Link>

          <Link className='submenu-item' to='/offer/branding/' >
          <img width="10px" className='icon-green'  alt="branding" src='/img/pencil-ruler.svg'/>
            Branding
          </Link>

          <ul className="fmenu"><Link className='submenu-item' to='/offer/graphic-design/' >
          <img width="10px" className='icon-green'  alt="branding" src='/img/pencil-alt.svg'/>
          Graphic design
          </Link>
          <li><Link className='submenu-item' to='/offer/graphic-design/logotypes/'>Logotypes</Link></li>
          <li><Link className='submenu-item' to='/offer/graphic-design/siv-visual-identification/'>Visual Identity</Link></li>
          <li><Link className='submenu-item' to='/offer/graphic-design/vector-graphic/'>Vector graphics</Link></li>
          <li><Link className='submenu-item' to='/offer/graphic-design/website-design/'>Web design</Link></li>
          </ul>

          <ul className="fmenu">
          <Link className='submenu-item' to='/offer/web-pages/' >
          <img width="10px" className='icon-green'  alt="websites" src='/img/code.svg'/>
            Web pages
          </Link>
          <li><Link className='submenu-item' to='/offer/web-pages/website-development/'>Website development</Link></li>
          <li><Link className='submenu-item' to='/offer/web-pages/ecommerce-shops-creation/'>Creating online stores</Link></li>
          <li><Link className='submenu-item' to='/offer/web-pages/web-applications/'>Web applications</Link></li>
          <li><Link className='submenu-item' to='/offer/web-pages/positioning-web-pages-seo/'>Website positioning</Link></li>
          </ul>

          <Link className='submenu-item' to='/offer/book-calendars/' >
          <img width="10px" className='icon-green'  alt="book calendars" src='/img/book.svg'/>
            Book Calendars
          </Link>

          <Link className='submenu-item' to='/offer/company-calendars/' >
          <img width="10px" className='icon-green'  alt="business calendars" src='/img/calendar-alt.svg'/>
          Company calendars
          </Link>

          <Link className='submenu-item' to='/offer/gadgets/'><img width="10px" className='icon-green'  alt="gadgets" src='/img/lightbulb.svg'/>Advertising gadgets</Link>
          </div>

          <div className='column removespace' style={{padding:'5px',marginTop:'30px'}}>
          <br /><br />

          <Link className='submenu-item' to='/offer/printouts/' >
          <img width="10px" className='icon-green'  alt="printouts" src='/img/map.svg'/>
          Advertising prints
          </Link>

          <Link className='submenu-item' to='/offer/outdoor-advertising/' >
          <img width="10px" className='icon-green'  alt="outdoor advertising" src='/img/object-ungroup.svg'/>
          Outdoor advertisements
          </Link>

          <Link className='submenu-item' to='/offer/photography/' >
          <img width="10px" className='icon-green'  alt="photography" src='/img/camera-retro.svg'/>
          Product photography
          </Link>

          <Link className='submenu-item' to='/offer/exhibition/' >
          <img width="10px" className='icon-green'  alt="Exhibition systems" src='/img/cubes.svg'/>
          Exhibition systems
          </Link>


          <ul className="fmenu">
          <Link className='submenu-item' to='/offer/filming/' >
          <img width="10px" className='icon-green'  alt="Advertising videos" src='/img/film.svg'/>
          Advertising videos
          </Link>
          <li><Link className='submenu-item' to='/offer/filming/animated-films/'>Animated films</Link></li>
          <li><Link className='submenu-item' to='/offer/filming/video/'>Video filming</Link></li>
          <li><Link className='submenu-item' to='/offer/filming/storyboard/'>Storyboard</Link></li>
          <li><Link className='submenu-item' to='/offer/filming/video-editing/'>Video editing</Link></li>
          </ul>


          <ul className="fmenu">
          <Link className='submenu-item' to='/offer/packaging/' >
          <img width="10px" className='icon-green'  alt="packaging" src='/img/box-open.svg'/>
            Packaging
          </Link>
          <li><Link className='submenu-item' to='/offer/packaging/cardboard-boxes/'>Cardboard boxes</Link></li>
          <li><Link className='submenu-item' to='/offer/packaging/decorative-boxes/'>Decorative boxes</Link></li>
          <li><Link className='submenu-item' to='/offer/packaging/storage-boxes/'>Storage boxes</Link></li>
          <li><Link className='submenu-item' to='/offer/packaging/gift-boxes/'>Gift boxes</Link></li>
          </ul>

          <Link className='submenu-item' to='/offer/vr/' >
          <img width="10px" className='icon-green'  alt="VR" src='/img/vr-cardboard.svg'/>
            Virtual reality
          </Link>
          </div>

        <div className='column' style={{marginTop:'20px'}}>
          <h5><b><Link style={{color:'white'}} to="/blog/">Blog</Link></b></h5>
          <br />
          {posts &&
            posts.slice(0,15)
            .filter(post => post.node.frontmatter.templateKey === 'article-page')
            .map(({ node: post }) => (
              <Link className='submenu-item' key={post.id} to={post.fields.slug} >
                {post.frontmatter.title}
              </Link>
          ))}

        </div>

        <div className='column' style={{marginRight:'5%',padding:'5px',marginTop:'25px'}}>
          <h5><b><Link style={{color:'white'}} to="/contact/">Contact</Link></b></h5>
          <br />
          <p className='submenu-item'>
          <img width="10px" className='icon-green'  alt="address" src='/img/map-marker-alt.svg'/>87 Piotra Ignuta St.</p>
          <p className='submenu-item'>
          <img width="10px" className='icon-green'  alt="address" src='/img/city.svg'/>54-151 Wrocław</p>
          <br />


          <a href="tel:+48 71 728 29 13" className='submenu-item' style={{textDecoration:'underline'}}>
          <img width="10px" className='icon-green'  alt="phone" src='/img/phone.svg'/>Phone: +48 71 728 29 13</a>


          <a href="mailto:bok@artopen.pl" className='submenu-item' style={{textDecoration:'underline'}}>
          <img width="10px" className='icon-green'  alt="email" src='/img/paper-plane.svg'/>bok@artopen.pl</a>


          <br />
          <p className='submenu-item'>
          <img width="10px" className='icon-green'  alt="opening hours" src='/img/clock.svg'/>Monday - Friday: 8:00 - 16:00</p>
          <br />

          <p className='submenu-item'>NIP: 8943133919</p>

          <p className='submenu-item'>REGON: 381593714</p>

          <p className='submenu-item'>KRS: 0000751913</p>

          <br />

        </div>

        <div className='column' style={{marginTop:'20px'}}>
          <h5><b><Link style={{color:'white'}} to="/">Art Open Sp. z o.o.</Link></b></h5>
          <br />
          <h6 className="submenu-item" style={{fontSize:'13px'}}><b>Color mode</b></h6>
          <br />
          <p className='control'>
              <a className="button-green tooltip" onClick={setdarkMode}>
              <img width="10px" id="dark-mode-img" className='icon-green'  alt="darkmode" src='/img/moon.svg'/>
              <span id="dark-mode-btn">dark mode</span><span className="tooltiptextup">Activate the dark color mode, relax your eyes and reduce energy consumption.</span></a>
            </p>
          <br />
          <h6 className="submenu-item" style={{fontSize:'13px'}}><b>Newsletter</b></h6>
          <br />

          <a onClick={newsEnter} className='button-green tooltip' > <img width="10px" className='icon-green'  alt="address" src='/img/address-card.svg'/>subscribe<span className="tooltiptextup">Click here and you will be able to subscribe to the newsletter, which will help you stay up to date with news. </span></a>
          <br />
          <br />
          <h6 className="submenu-item" style={{fontSize:'13px'}}><b>Form</b></h6>
          <br />
          <a href="/quote-art-open/" target="_blank" className='button-green tooltip' > <img width="10px" className='icon-green'  alt="address" src='/img/envelope-alt.svg'/>get a quote<span className="tooltiptextup">After clicking, you will be redirected to the subpage with forms containing services from our offer. Answer the given questions and send a query.</span></a>
          <br />
          <br />
          <h6 className="submenu-item" style={{fontSize:'13px'}}><b>Calendar Wizard</b></h6>
          <br />
          <a href="/calendar-creator-online/" target="_blank" className='button-green tooltip' > <img width="10px" className='icon-green'  alt="address" src='/img/book.svg'/>calendar Wizard<span className="tooltiptextup">Let your imagination run wild and design your own calendar now.</span></a>
          <br />
          <br />
          <h6 className="submenu-item" style={{fontSize:'13px'}}><b>Leave us a review</b></h6>
          <br />
          <a href="https://g.page/artopenreklama/review?rc" target="_blank" rel="noopener noreferrer" className='button-green tooltip' > <img width="10px" className='icon-green'  alt="address" src='/img/address-card.svg'/>Google reviews<span className="tooltiptextup">Write an opinion about our company on Google.</span></a>
          <br /><br />
          <h6 className="submenu-item" style={{fontSize:'13px'}}><b>Polish version</b></h6>
          <br />
          <a style={{display: 'flex',width: 'fit-content',alignItems:'center'}} href="https://artopen.pl" className='button-green tooltip' > <img width="15px" className='icon-green' style={{filter:'none'}} alt="polish version" src='/img/polish.png'/>Polish<span className="tooltiptextup">Polish language</span></a>


         {/*}//TODO: Google play badge
          <br /><h5 style={{marginTop:'20px'}}><b>Aplikacja</b></h5>
          <Link to='http://play.google.com/store/?pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img className="oimg" alt='pobierz z Google Play' style={{maxWidth:'150px'}} src='https://play.google.com/intl/en_us/badges/static/images/badges/pl_badge_web_generic.png'/></Link>
          */}
        </div>




      </div>
        <div className='has-text-centered'>
        <a rel="noreferrer" href='https://facebook.com/artopenstudioreklamy/' target="_blank">
          <img width="25px" className='icon-green' alt="facebook" src='/img/facebook-square.svg'/>
        </a>
        <a rel="noreferrer" href='https://www.youtube.com/channel/UCR45VIn9iEmnQo7JU_FL2uQ/' target="_blank">
          <img width="25px" className='icon-green' alt="youtube" src='/img/youtube-square.svg'/>
        </a>
        <a rel="noreferrer" href='https://www.linkedin.com/company/art-open-studio-reklamy/' target="_blank">
          <img width="25px" className='icon-green' alt="linkedin" src='/img/linkedin.svg'/>
        </a>
        <a rel="noreferrer" href='https://twitter.com/AReklamy/' target="_blank">
          <img width="25px" className='icon-green' alt="tweeter" src='/img/twitter-square.svg'/>
        </a>
        <a rel="noreferrer" href='https://www.instagram.com/artopen.pl/' target="_blank">
          <img width="25px" className='icon-green' alt="instagram" src='/img/instagram-square.svg'/>
        </a>
        <a rel="noreferrer" href='https://www.behance.net/ArtOpenStudioReklamy/' target="_blank">
          <img width="25px" className='icon-green' alt="behance" src='/img/behance-square.svg'/>
        </a>

          <br />
          <br />
          <p style={{color:'white',fontSize:'12px'}}>
            <Link className='link-green' style={{color:'white'}} to="/">{new Date().getFullYear()} © Art Open | {config.copyright}</Link> | <Link className='link-green' to="/privacy-policy/"> Privacy policy </Link>
            | <Link className='link-green' to="/privacy-policy/#cookies"> Cookies </Link>
            | <a className='link-green' target="_blank" href="https://artopen.co/sitemap.xml/"> Sitemap </a>
          </p>

        </div>
      </div>

    <div onLoad={loadScroll} id='backtotop'
      style={{display:'none',position:'fixed',right:'2px',
      bottom:'4px',padding:'4px', width:'27px',textAlign:'center',
      height:'27px',backgroundColor:'#111111',borderRadius:'5px'}}>
      <Link to="#"><img width="20px"  alt="backtotop" src='/img/angle-up.svg'/></Link>
    </div>

    {/*<MessengerCustomerChat
      pageId="1673443436278120"
      appId="830740164459215"
      language="en_EN"
      loggedInGreeting="Welcome to the Art Open website, feel free to contact us."
      loggedOutGreeting="Welcome to the Art Open website, feel free to contact us."
    />*/}


    </footer>
  )
}
}

const newsEnter = () => {
  let i = 0;
  console.log('enter modal');
  document.getElementById('newsletter').style.display = 'block';
  document.getElementById('newsletter').style.transition = 'opacity 0.5s';

  setTimeout(function(){document.getElementById('newsletter').style.opacity = '1';},500);
}


function scrollFunction() {
  if (document.getElementById("backtotop") !== null){
  if ( document.documentElement.scrollTop > 100) {
    document.getElementById("backtotop").style.display = "block";
  } else {
    document.getElementById("backtotop").style.display = "none";
  }
}
}


function loadScroll(){
  console.log('loaded');
  document.onscroll = function() {scrollFunction()};
}







Footer.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export default () => (
  <StaticQuery
    query={graphql`
      query footerQuery {
        allMarkdownRemark(
          limit: 15,
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: { frontmatter: { templateKey: { eq: "article-page" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
                templateKey
              }
            }
          }
        }
      }
    `}
    render={(data, count) => <Footer data={data} count={count} />}
  />
)
